'use strict';

var style = require('./style');

module.exports = style({
  prop: 'boxShadow',
  key: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/box-shadow.js
// module id = 652
// module chunks = 3